module.exports = __webpack_public_path__ + "img/sashimi_teisyokujpg.eace071c.jpg";